import React from 'react';

/**
 * AppTableEmptyState — Centered empty/loading placeholder row for tables.
 *
 * Must be rendered inside a <tbody> wrapped in a <tr>.
 *
 * @param {number}  colSpan       — number of columns the empty cell should span
 * @param {string}  [icon]        — PrimeIcons class, e.g. "pi pi-search"
 * @param {string}  [message]     — text to display
 * @param {boolean} [loading]     — show spinner instead of icon
 */
const AppTableEmptyState = ({
    colSpan,
    icon = 'pi pi-search',
    message = 'No se encontraron resultados',
    loading = false,
}) => (
    <tr>
        <td colSpan={colSpan}>
            <div className="tk-empty">
                <i className={loading ? 'pi pi-spin pi-spinner' : icon} />
                <span>{loading ? 'Cargando...' : message}</span>
            </div>
        </td>
    </tr>
);

export default AppTableEmptyState;
